import { stats, expandBenefits } from "../../data/mock";
import { Users, Globe, TrendingUp, ChevronRight } from "lucide-react";

const iconMap = {
  Users: Users,
  Globe: Globe,
  TrendingUp: TrendingUp
};

export const StatsSection = () => {
  return (
    <section id="stats" className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-brand-950 via-brand-900 to-brand-950" />
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-light/6 rounded-full blur-3xl animate-float-slow" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-brand-500/6 rounded-full blur-3xl animate-float" />

      {/* Subtle grid pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'radial-gradient(circle, #00CCFF 1px, transparent 1px)',
        backgroundSize: '48px 48px'
      }} />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-5 py-2 rounded-full bg-brand-light/10 border border-brand-light/15 text-brand-light text-xs font-bold uppercase tracking-widest mb-5 brand-heading">
            Impacto Real
          </span>
          <h2 className="brand-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4">
            Expande Tu Iglesia
          </h2>
          <p className="text-brand-300/50 text-lg max-w-2xl mx-auto">
            Resultados comprobados que transforman ministerios
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-20">
          {stats.map((stat, index) => {
            const Icon = iconMap[stat.icon];
            return (
              <div
                key={index}
                className="group relative p-10 rounded-3xl bg-white/[0.04] backdrop-blur-sm border border-brand-light/10 hover:border-brand-light/30 transition-all duration-500 hover:bg-white/[0.07] text-center animate-pulse-glow"
                style={{ animationDelay: `${index * 0.5}s` }}
              >
                <div className="relative z-10">
                  <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-brand-light/10 flex items-center justify-center group-hover:bg-brand-light/20 group-hover:scale-110 transition-all duration-300">
                    <Icon className="w-8 h-8 text-brand-light" />
                  </div>
                  <div className="text-5xl md:text-7xl font-bold text-white mb-3 tracking-tight brand-heading">
                    {stat.value}
                  </div>
                  <p className="text-brand-200/50 text-base font-medium">
                    {stat.label}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Expand Benefits */}
        <div className="max-w-2xl mx-auto">
          <div className="space-y-4">
            {expandBenefits.map((benefit, index) => (
              <div
                key={index}
                className="flex items-center gap-4 p-4 rounded-2xl bg-white/[0.04] border border-brand-light/8 hover:border-brand-light/25 hover:bg-white/[0.07] transition-all duration-300 group"
              >
                <div className="w-8 h-8 rounded-lg bg-brand-light/15 flex items-center justify-center flex-shrink-0 group-hover:bg-brand-light/25 transition-all duration-300 group-hover:scale-110">
                  <ChevronRight className="w-4 h-4 text-brand-light" />
                </div>
                <span className="text-white/60 font-medium group-hover:text-white/85 transition-colors">
                  {benefit}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
